import { ImagenesTrabajos } from "@/types";
import { safeFetch } from "@/api/safeFetch";
import { fixImageOrientation } from "./fixImageOrientation";

/* ============================================================
   SUBIR IMAGEN DE TRABAJO (carpeta profesionales/)
============================================================ */
export const subirImagenTrabajo = async (
  file: File,
  perfilProfesionalId: number,
): Promise<ImagenesTrabajos> => {

  // 🔹 Corregir orientación antes de subir
  const fixedFile = await fixImageOrientation(file);

  const formData = new FormData();
  formData.append("file", fixedFile);
  formData.append("perfil_profesional_id", String(perfilProfesionalId));
  formData.append("esTrabajo", "true");

  const res = await safeFetch(`/api/upload/profesionales`, {
    method: "POST",
    body: formData,
  });

  if (!res.ok) throw new Error("Error al subir imagen de trabajo");

  const data = await res.json();

  return {
    imagen_trabajo_id: undefined,
    imagen_trabajo_realizado: data.url,
  };
};

/* ============================================================
   SUBIR FOTO DE PERFIL (carpeta profesionales/)
============================================================ */
export const subirFotoPerfil = async (
  file: File,
  perfilProfesionalId: number,
) => {

  const fixedFile = await fixImageOrientation(file);

  const formData = new FormData();
  formData.append("file", fixedFile);
  formData.append("perfil_profesional_id", String(perfilProfesionalId));
  formData.append("esTrabajo", "false");

  const res = await safeFetch(`/api/upload/profesionales`, {
    method: "POST",
    body: formData,
  });

  if (!res.ok) throw new Error("Error subiendo foto de perfil");

  return await res.json();
};

/* ============================================================
   SUBIR LOGO (carpeta imgLogos/)
============================================================ */
export const subirLogo = async (
  file: File,
  perfilProfesionalId: number,
) => {

  // 🔹 Corregir orientación antes de subir
  const fixedFile = await fixImageOrientation(file);

  const formData = new FormData();
  formData.append("file", fixedFile);
  formData.append("perfil_profesional_id", String(perfilProfesionalId));

  const res = await safeFetch(`/api/upload/imgLogos`, {
    method: "POST",
    body: formData,
  });

  if (!res.ok) throw new Error("Error subiendo logo");

  return await res.json();
};

/* ============================================================
   SUBIR FIRMA (archivo)
============================================================ */
export const subirFirmaArchivo = async (
  file: File,
  perfilProfesionalId: number,

) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("perfil_profesional_id", String(perfilProfesionalId));

  const res = await safeFetch(`/api/upload/firmas`, {
    method: "POST",
    body: formData,
  });

  if (!res.ok) throw new Error("Error subiendo firma");

  return await res.json();
};


/* ============================================================
   ELIMINAR IMAGEN EN SERVIDOR (S3)
============================================================ */
export async function eliminarImagenEnServidor(
  ruta: string,
  tipo:
    | "imgLogos"
    | "profesionales"
    | "firmas"
    | "imgLandingSlider"
    | "imgLandingEquipo"
    | "ofertas"
): Promise<void> {

  const res = await safeFetch(
    `/api/upload/${tipo}`,
    {
      method: "DELETE",
      body: JSON.stringify({
        path: ruta
      }),
    }
  );

  if (!res.ok) {
    const data = await res.json().catch(() => null);

    throw new Error(
      data?.message ||
      "Error borrando imagen"
    );
  }
}
